import { render, staticRenderFns } from "./document.vue?vue&type=template&id=493ef174&scoped=true"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"
import style0 from "./document.vue?vue&type=style&index=0&id=493ef174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ef174",
  null
  
)

export default component.exports